<section class="p-3">
    <div class="row">

        <h5 class="fw-bold mb-3">
            <i [ngClass]="isEditMode
          ? 'fas fa-edit'
          : 'fas fa-file-invoice-dollar'" class="me-2">
            </i>
            {{ isEditMode ? 'Update Expense Details' : 'Add Expense Details' }}
        </h5>

        <!-- Expense Form -->
        <div class="col-12 col-md-4">
            <form [formGroup]="expenseForm" (ngSubmit)="expenseFormValidation()" novalidate>

                <div class="mb-3">
                    <label for="expenseName" class="form-label">
                        Expense Name <span class="text-danger">*</span>
                    </label>

                    <input type="text" class="form-control" id="expenseName" formControlName="name"
                        placeholder="e.g., Office Rent, Utility Bills" maxlength="100" [ngClass]="{
              'is-invalid': expenseForm.get('name')?.invalid &&
                            expenseForm.get('name')?.touched,
              'is-valid': expenseForm.get('name')?.valid &&
                          expenseForm.get('name')?.touched
            }" />

                    <div class="invalid-feedback" *ngIf="expenseForm.get('name')?.touched &&
                      expenseForm.get('name')?.hasError('required')">
                        <i class="fas fa-exclamation-circle me-1"></i>
                        {{ expenseErrors.name || 'Expense Name is required' }}
                    </div>

                    <div class="invalid-feedback" *ngIf="expenseForm.get('name')?.touched &&
                      expenseForm.get('name')?.hasError('maxlength')">
                        Expense Name cannot exceed 100 characters.
                    </div>
                </div>

                <div class="d-flex justify-content-end gap-2 mb-3">
                    <button type="button" class="btn btn-outline-secondary rounded-3" (click)="cancelForm()">
                        Cancel
                    </button>

                    <button type="submit" class="btn btn-secondary rounded-3" [disabled]="isSubmitting">
                        <i [ngClass]="isEditMode
                ? 'fas fa-save'
                : 'fas fa-plus'" class="me-1">
                        </i>
                        {{ isEditMode ? 'Update' : 'Save' }}
                    </button>
                </div>
            </form>
        </div>

        <!-- Expense List -->
        <div class="col-12 col-md-8">
            <div class="card p-3 border rounded-3 mt-md-0 mt-3">
                <div class="card-body">

                    <div class="row align-items-center mb-3">
                        <div class="col-12 col-lg-4 mb-2 mb-lg-0">
                            <h5 class="fw-bold mb-1">Expense List</h5>
                            <small class="text-muted">
                                All uploaded expense details
                            </small>
                        </div>

                        <div class="col-12 col-lg-8">
                            <div class="row g-2 align-items-center">

                                <!-- Search -->
                                <div class="col-12 col-sm-7">
                                    <div class="input-group">
                                        <span class="input-group-text bg-white">
                                            <i class="fas fa-search text-muted"></i>
                                        </span>

                                        <input type="text" class="form-control" [(ngModel)]="searchText"
                                            [ngModelOptions]="{ standalone: true }" placeholder="Search expense..."
                                            autocomplete="off" />

                                    </div>
                                </div>

                                <!-- Status Filter -->
                                <div class="col-8 col-sm-4">
                                    <select class="form-select" [(ngModel)]="selectedStatus"
                                        [ngModelOptions]="{ standalone: true }">

                                        <option value="">All Status</option>
                                        <option value="ACTIVE">Active</option>
                                        <option value="INACTIVE">Inactive</option>
                                    </select>
                                </div>

                                <!-- Reset -->
                                <div class="col-4 col-sm-1 text-center">
                                    <button type="button" class="btn btn-outline-secondary" title="Reset filters"
                                        aria-label="Reset filters" (click)="resetFilters()">
                                        <i class="fas fa-sync-alt"></i>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                    <!-- Table -->
                    <div class="table-style table-responsive table-bordered">
                        <table class="table table-head-fixed text-nowrap text-center">

                            <thead class="table-light">
                                <tr>
                                    <th>S.No</th>
                                    <th>Expense Name</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>


                            <tbody>
                                <tr *ngFor="let expense of filteredExpenses; let i = index">
                                    <td>
                                        {{ i + 1 }}
                                    </td>
                                    <td>
                                        {{ expense.name || '-' }}
                                    </td>

                                    <td>
                                        <span class="badge rounded-pill px-3 py-2 fw-semibold" [ngClass]="{
          'bg-success-subtle text-success':
            (expense.status || '').trim().toUpperCase() === 'ACTIVE',
          'bg-danger-subtle text-danger':
            (expense.status || '').trim().toUpperCase() !== 'ACTIVE'
        }">
                                            {{
                                            (expense.status || '').trim().toUpperCase() === 'ACTIVE'
                                            ? 'Active'
                                            : 'Inactive'
                                            }}
                                        </span>
                                    </td>

                                    <td>
                                        <div class="d-flex justify-content-center align-items-center gap-3">
                                            <button type="button" class="btn btn-link p-0 text-secondary"
                                                title="Edit expense" (click)="editExpenseDetails(expense)">
                                                <i class="fas fa-edit fs-5"></i>
                                            </button>

                                            <div class="form-check form-switch mb-0 ms-2">
                                                <input class="form-check-input" type="checkbox" role="switch"
                                                    [id]="'expense-switch-' + expense.expenseSeq" [checked]="
              (expense.status || '').trim().toUpperCase() === 'ACTIVE'
            " [disabled]="isSubmitting" (change)="updateExpenseToggle(
              expense,
              expenseDetails.indexOf(expense),
              $event
            )" />
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                <tr *ngIf="filteredExpenses.length === 0">
                                    <td colspan="3" class="text-center text-danger py-4">
                                        <i class="fas fa-money-bill-wave fa-2x d-block mb-2"></i>
                                        <span class="fw-bold">No expense data found</span>
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                    </div>

                </div>
            </div>
        </div>

    </div>
</section>